import dc from 'dc'
import { schemeCategory10 } from 'd3'
import 'dc/dc.css'

dc.config.defaultColors(schemeCategory10)
dc.disableTransitions = true
dc.constants.EVENT_DELAY = 1
